module.exports = __webpack_public_path__ + "img/two_banner_mobile_bg2.0695cac7.jpg";